module.exports = __webpack_public_path__ + "img/16581282_L.0f4dcb14.png";